import React, {useState, useEffect} from 'react'
import { connect } from 'react-redux';


import {getCalculateFiled, postCalculateFiled} from 'actions/uploadFile'
// reactstrap components
import {
    Modal,
    Card,
    CardHeader,
    CardBody,
    CardTitle,
    Form,
    FormGroup,
    Label,
    Button,
    Row,
    Col,
  } from "reactstrap";

// conponents

import DataImportPage from '../DataImportPage';
import CalculateFileTable from "./CalculateFileTable";


const CalculateDataForm = ({}) => {

    return (
        <DataImportPage>
            <Row>
                <Col md={12}>
                    <Card>
                        <CardBody>
                            <CalculateFileTable/>
                        </CardBody>
                    </Card>
                </Col>
            </Row>

    </DataImportPage>
)
}

const mapStateToProps = (state) => ({
  UploadFile: state.UploadFile,
});

export default connect(mapStateToProps, {getCalculateFiled, postCalculateFiled})(CalculateDataForm)
